<template>
    <div class="legal-person-step1" v-loading="pageLoading">
        <el-form ref="formData" class="sr-from-single" label-width="150px" :model="formData">
            <el-form-item prop="entAccountName" label="对公账户名" :rules="[{ required: true, message: '请输入对公账户名' }]">
                <el-input v-model="formData.entAccountName" placeholder="请输入对公账户名" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item prop="entBankCard" label="对公银行卡号" :rules="[{ required: true, message: '请输入对公银行卡号' }]">
                <el-input v-model="formData.entBankCard" placeholder="请输入对公银行卡号" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item prop="entBankHeadCode" label="开户总行" :rules="[{ required: true, message: '请输入开户总行' }]">
                <el-select v-model="formData.entBankHeadCode" :filterable="true" :remote="true" @change="setBankName"
                    :remote-method="(val) => remoteBank(val, 1)" :loading="bankTypeLoading" placeholder="请输入总行关键字，例如：工商银行">
                    <el-option v-for="item in bankTypeOptions" :key="item.label" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="entBankCode" label="开户行支行" :rules="[{ required: true, message: '请输入开户行支行' }]">
                <el-select v-model="formData.entBankCode" :filterable="true" :remote="true" @change="setBankChildName"
                    :remote-method="(val) => remoteBank(val, 2)" :loading="bankTypeLoading"
                    placeholder="请输入开户行名称关键字，例如：成都支行">
                    <el-option v-for="item in bankCodeOptions" :key="item.label" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="previousStep()">上一步</el-button>
                <el-button type="primary" :loading="loading" @click="onSubmit">收款账户已确认，请打款</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { enterpriseBankConfirm, queryBank, setEnterpriseStep } from '@/api/user';
export default {
    components: {},
    data() {
        return {
            pageLoading: false,
            loading: false,
            formData: {
                entAccountName: '', // 对公账户名
                entBankBranchOfficeName: '', // 开户行支行
                entBankCode: '', // 开户行支行code
                entBankCard: '', // 对公银行卡号
                entBankHandOfficeName: '', // 开户总行名称
                entBankHeadCode: '', // 开户总行code
            },
            bankTypeOptions: [], // 银行类型列表
            bankTypeLoading: false,
            bankCodeOptions: [], // 支行列表
            bankCodeLoading: false,
        };
    },
    mounted() {
        this.initFrom();
    },
    methods: {
        setBankName(code) {
            this.bankTypeOptions.forEach((bank) => {
                if (bank.value == code) this.formData.entBankHandOfficeName = bank.label;
            });
        },
        setBankChildName(code) {
            this.bankCodeOptions.forEach((bank) => {
                if (bank.value == code) this.formData.entBankBranchOfficeName = bank.label;
            });
        },
        async previousStep() {
            const flag = await this.$confirm(`返回后当前页面的信息将不会保存。`, '确定要返回操作吗？');
            if (flag === 'cancel') return;
            const respnose = await setEnterpriseStep(1);
            const { state, msg } = respnose.data;
            if (!state) return this.$message.error(msg || '返回上一步失败，请稍后尝试');
            this.$emit('updateStep');
        },
        // 表单初始化 注：只有是法人本人才能进行初始化设置
        async initFrom() {
            const { certifyInfo } = this.$store.getters;
            this.formData = { ...this.formData, ...certifyInfo };
            if (certifyInfo.entBankCode) {
                this.bankCodeOptions = [{ value: certifyInfo.entBankCode, label: certifyInfo.entBankBranchOfficeName }];
            }
            if (certifyInfo.entBankHeadCode) {
                this.bankTypeOptions = [{ value: certifyInfo.entBankHeadCode, label: certifyInfo.entBankHandOfficeName }];
            }
        },
        /**
         * 查询银行信息
         * @param {String} query 银行名关键字
         * @param {Number} type 查询银行类型 1：总行名称 2：支行名称
         */
        async remoteBank(query, type) {
            if (!query) return type == 1 ? (this.bankTypeOptions = []) : (this.bankCodeOptions = []);
            type == 1 ? (this.bankTypeLoading = true) : (this.bankCodeLoading = true);
            const res = await queryBank(query, type == 1 ? '' : this.formData.entBankHeadCode).finally(() => {
                type == 1 ? (this.bankTypeLoading = false) : (this.bankCodeLoading = false);
            });
            if (!res.data.state) return this.$message.error(res.data.msg);
            const remoteOptions = (res.data.result || []).map((item) => {
                return { label: item.name, value: item.code };
            });
            type == 1 ? (this.bankTypeOptions = remoteOptions) : (this.bankCodeOptions = remoteOptions);
        },
        async onSubmit() {
            const valid = await this.$refs['formData'].validate();
            if (!valid) return;
            this.loading = true;
            const formData = JSON.parse(JSON.stringify(this.formData));
            const respnose = await enterpriseBankConfirm(formData);
            const { state, msg } = respnose.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '银行信息验证失败，请稍后尝试');
            this.$emit('updateStep');
        },
    },
};
</script>
<style lang="scss" scoped></style>
